import { TextItalic } from '@phosphor-icons/react';

export default TextItalic;
